import { Address } from '@models/address';
import { Area } from '@models/area';
import { Auditable } from '@models/auditable';
import { Maintenance } from '@models/maintenance';
import { Severity } from '@models/severity';
import { ndefault } from '@models/util';
import z from 'zod';

export type Location = z.infer<typeof Location>;
export type LocationAggregations = z.infer<typeof LocationAggregations>;
export type LocationFlags = z.infer<typeof LocationFlags>;
export type KnownLocationFlags = z.infer<typeof KnownLocationFlags>;

export const LocationAggregations = z.object({
  deviceTypes: z.record(z.string(), z.number()).default({}),
  deviceStates: z.record(z.string(), z.partialRecord(Severity, z.number())).default({}),
});

export const KnownLocationFlags = z.object({
  excludedFromReporting: z.boolean().nullish(),
});

export const LocationFlags = z.intersection(KnownLocationFlags, z.record(z.string(), z.unknown()));

export const Location = Auditable.extend({
  id: z.string(),
  name: ndefault(z.string(), ''),
  address: Address.nullish(),
  orgs: ndefault(z.array(z.string()), []),
  areas: ndefault(z.array(Area), []),
  maintenance: Maintenance.nullish(),
  aggregations: LocationAggregations.nullish(),
  flags: LocationFlags.nullish(),
});
